import { render } from "./NavFullScreen.vue?vue&type=template&id=05e1303b&scoped=true"
import script from "./NavFullScreen.vue?vue&type=script&lang=js"
export * from "./NavFullScreen.vue?vue&type=script&lang=js"

import "./NavFullScreen.vue?vue&type=style&index=0&id=05e1303b&scoped=true&lang=scss"

import exportComponent from "/Users/raulbajmuhametov/work/vue/grany/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e1303b"]])

export default __exports__